
import Vue from 'vue'
import TopQuestionAndAnswer from '../components/molecules/TopQuestionAndAnswer.vue'
import Triangle from '~/components/atoms/Triangle.vue'
import Footer from '~/components/atoms/Footer.vue'
import FloatBar from '~/components/atoms/FloatBar.vue'

export default Vue.extend({
  components: {
    TopQuestionAndAnswer,
    Triangle,
    FloatBar,
    Footer,
  },
  layout: 'public',
  data() {
    return {
      tweets: [],
    }
  },
  async fetch() {
    const resultUrl = process.browser
      ? '/staticapi/sexuality/tweet/twitter_timline.json'
      : `${process.env.JOBRAINBOW_STATIC_PATH}/sexuality/tweet/twitter_timline.json`
    const fetched = await this.$axios.$get(resultUrl)
    this.tweets = fetched.tweets as []
  },
  head() {
    return {
      title: `セクシュアリティ（LGBTQ+）診断`,
      link: [{ rel: 'canonical', href: `${process.env.CLIENT_BASE_URL}/` }],
      meta: [
        { hid: 'og:type', property: 'og:type', content: 'article' },
        { hid: 'og:title', property: 'og:title', content: `セクシュアリティ（LGBTQ+）診断` },
        { hid: 'og:image', property: 'og:image', content: `${process.env.CLIENT_BASE_DOMAIN}${require('~/assets/img/top_ogp.png')}` },
        {
          hid: 'description',
          name: 'description',
          property: 'description',
          content: `5分で完了する無料の診断で、貴方のセクシュアリティ（性のあり方）が詳しくわかります。自分はLGBTQ+のどれかな？なんとなく性に関してモヤモヤしている。自分の恋愛観が周りと違う気がする。そんな方におすすめです。 `,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: `5分で完了する無料の診断で、貴方のセクシュアリティ（性のあり方）が詳しくわかります。自分はLGBTQ+のどれかな？なんとなく性に関してモヤモヤしている。自分の恋愛観が周りと違う気がする。そんな方におすすめです。 `,
        },
        { hid: 'og:url', property: 'og:url', content: `${process.env.CLIENT_BASE_URL}/` },
        { hid: 'twitter:card', property: 'twitter:card', content: 'summary_large_image' },
      ],
    }
  },
  methods: {
    shareTwitter() {
      const shareURL = 'http://twitter.com/share'
      const shareText = ''
      const jobrainbowURL = `${process.env.CLIENT_BASE_URL}/`
      window.open(`${shareURL}?text=${shareText}&url=${jobrainbowURL}&via=jobrainbow&related=jobrainbow`, '_blank', 'noreferrer,nofollow')
    },
    shareLINE() {
      const shareURL = 'https://social-plugins.line.me/lineit/share'
      const jobrainbowURL = `${process.env.CLIENT_BASE_URL}/`
      window.open(`${shareURL}?url=${jobrainbowURL}`, '_blank', 'noreferrer,nofollow')
    },
    shareFacebook() {
      const shareURL = 'https://www.facebook.com/sharer/sharer.php'
      const jobrainbowURL = `${process.env.CLIENT_BASE_URL}/`
      window.open(`${shareURL}?u=${jobrainbowURL}`, '_blank', 'noreferrer,nofollow')
    },
  },
})
